<button (click)="signInWithGoogle()" class="bg-white d-flex justify-content-between my-2 fs12 fw500 p-3 text-uppercase mx-auto" style="color: #757575;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 1, 0.27);
    border: solid 0.2px #d0d8e2;">
    <span>Continue with Google</span>
    <img src="assets/images/svg/google.svg" alt="Google" />
</button>